import {eventChannel, END} from 'redux-saga'
import {take, put, call} from 'redux-saga/effects'
import Config from "../config";
import {LOG_STORAGE_KEY} from "new-constants/common.constants";
import {sendClientLogs} from "../actions/api.actions";
import {select} from "@redux-saga/core/effects";
import {trySendLogs} from "../actions/client-log.actions";

const LOCAL_STORAGE_KEY = LOG_STORAGE_KEY + Config.BaseServerUrl;

const CHECK_LOG_INTERVAL = 10 * 1000;
const BATCH_SIZE = 10;

function initCheckLog() {
	return eventChannel(emitter => {
			const iv = setInterval(() => {
				emitter(trySendLogs());
			}, CHECK_LOG_INTERVAL);

			return () => {
				clearInterval(iv)
			}
		}
	)
}

function* trySendLogsToServer() {
	const log = JSON.parse(localStorage?.getItem(LOCAL_STORAGE_KEY));
	const {fetchProgress} = yield select();
	const isSomeRequestInProgress = Object.values(fetchProgress).filter(value => !!value).length > 0;


	if (!isSomeRequestInProgress && log?.length > 0) {
		const batch = log.slice(0, BATCH_SIZE);

		yield put(sendClientLogs(batch));
	}
}


export function* clientLogSenderSaga() {
	const checkLogChannel = yield call(initCheckLog)
	try {
		while (true) {
			yield take(checkLogChannel);
			yield call(trySendLogsToServer);
		}
	} finally {
		console.log('client log terminated')
	}
}
